import { combineReducers } from 'redux';

import * as types from 'modules/chat/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import apiError from './apiError';
import context from './context';
import history from './history';
import isLoading from './isLoading';
import isReady from './isReady';
import links from './links';
import mediaDrawer from './mediaDrawer';
import page from './page';

/**
 * @typedef {{
 *  page: import("modules/global/generic.types").Page,
 *  links: import("modules/global/generic.types").Link[],
 *  isReady: boolean,
 *  context: import("./context").ChatUIDetailsContextReducer,
 *  history: import("./history").ChatUIDetailsHistoryReducer,
 *  mediaDrawer: import("./mediaDrawer").MediaDrawerState,
 *  apiError: string | null,
 *  isLoading: boolean,
 *  isPosting: boolean,
 * }} ChatUIDetailsReducer
 */
export default combineReducers({
  // Messages slice
  page,
  links,
  apiError,
  isLoading,
  // Others reducers
  context,
  history,
  isReady,
  mediaDrawer,
  isPosting: loading(types.POST_MESSAGE),
});
